import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PagePipe} from './page.pipe';
import {SumPipe} from './sum.pipe';
import {MyDatePipe} from './my-date.pipe';
import {SafeHtmlPipe} from './safe-html.pipe';
import {SafeUrlPipe} from './safe-url.pipe';
import {ImplodePipe} from './implode.pipe';
import {StyleNewsBodyPipe} from './style-news-body.pipe';
import {ValidUrlPipe} from './valid-url.pipe';


@NgModule({
  declarations: [
    PagePipe,
    SumPipe,
    MyDatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    StyleNewsBodyPipe,
    ImplodePipe,
    ValidUrlPipe
  ],
  exports: [
    PagePipe,
    SumPipe,
    MyDatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    StyleNewsBodyPipe,
    ImplodePipe,
    ValidUrlPipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipesModule {
}
